import { FC } from 'react';

import { IconProps } from '../types';

const ProtectingIcon: FC<IconProps> = ({ size, ...props }) => (
  <svg
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    {...props}
    aria-hidden="true"
  >
    <path
      d="M19.9996 36.1519C19.9996 36.1519 34.4679 32.9367 34.4679 18.4683V7.21519C29.3188 7.21519 24.6455 6.04004 19.9996 4C15.3536 6.04004 10.6804 7.21519 5.53125 7.21519V18.4683C5.53125 32.9367 19.9996 36.1519 19.9996 36.1519Z"
      stroke="#030303"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.9968 21.5295L16.9343 25.467L26.9968 14.5295"
      stroke="#030303"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ProtectingIcon;
